module.exports = __webpack_public_path__ + "img/gubi.579f807b.png";